import {
  call,
  put,
  takeEvery,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import {
  showErrorNotification,
} from 'store/shared/actions';
import { DELETE_SET_SUCCESS, SET_CREATE_SUCCESS, SET_EDIT_SUCCESS } from 'store/set/constants';
import sortByName from 'library/helpers/sort-by-name';
import * as constants from './constants';
import * as actions from './actions';

function* getSets(action) {
  try {
    const params = {
      query: {
        limit: 150,
        name: action?.payload?.name ?? '',
      },
    };

    const { data } = yield call(request, API.BROWSE_SETS_BY_NAME, 'GET', params);

    yield put(actions.getSetsSuccess(data.sort(sortByName)));
  } catch (e) {
    yield put(actions.getSetsError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getSetsWatcher() {
  // DELETE_SET, SET_CREATE and SET_EDIT actions to be removed from above
  // when search by set name parts is ready on API
  yield takeEvery([constants.GET_SETS, DELETE_SET_SUCCESS, SET_CREATE_SUCCESS, SET_EDIT_SUCCESS], getSets);
}
